"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchEvent = isTouchEvent;
exports.getEventTarget = getEventTarget;
const browser_rum_core_1 = require("@datadog/browser-rum-core");
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && (0, browser_rum_core_1.isNodeShadowHost)(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map